import { render, staticRenderFns } from "./CorsiDashboard.vue?vue&type=template&id=2221db9c&scoped=true&"
import script from "./CorsiDashboard.vue?vue&type=script&lang=js&"
export * from "./CorsiDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CorsiDashboard.vue?vue&type=style&index=0&id=2221db9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2221db9c",
  null
  
)

export default component.exports